import React, { useEffect } from 'react';
import queryString from 'query-string';
import Header from '../../components/Header';
import { connect } from 'react-redux';
import { userActionsTypes } from '../../redux/user/actions';
import { SuccessPayment } from './SuccessPayment';
import { appointmentActionsTypes } from '../../redux/appointment/actions';
import { useLocation, useParams } from 'react-router';
import { PaymentForm } from './PaymentForm';
import Notification from '../../components/Notification';

function AnonymousPayment({
  userData,
  appointmentsData,
  getMpPreference,
  getAppointmentLight,
  updateAppointmentLight,
  deleteMessages,
}) {
  const { appointmentId } = useParams();
  let video_link = `${process.env.REACT_APP_VIDEO_URL}submit_code/${appointmentId}`;
  const goToVideo = () => {
    window.location.href = video_link;
  };
  const location = useLocation();
  let { status } = queryString.parse(location.search);

  useEffect(() => {
    //this use effect is only used when we dont have status in queryparams
    if (!status) {
      getAppointmentLight(appointmentId);
    }

    // traer el appointment solo en el primer render (lo vuelvo a traer cuando se hace el pago)
  }, [appointmentsData.success.genericMessage]); // esto es para correr de nuevo el useEffect cuando se haga update del appointment.

  // useEffect(() => {
  //   if (status) {
  //     !appointmentsData.success.genericMessage &&
  //       getAppointmentLight(appointmentId); // this is needed becouse we want only one get appointment request.
  //     if (
  //       appointmentsData.success.genericMessage ==
  //         'Success get appointments!' &&
  //       status[0] == 'success'
  //     ) {
  //       updateAppointmentLight(appointmentId, {
  //         is_payed: true,
  //         code: appointmentsData.appointments[0].video_conference_code,
  //       }); // update status of the appointmen
  //     }
  //   }
  // }, [appointmentsData.success]);

  return (
    <>
      {status && status[0] == 'failure' && (
        <Notification
          type="error"
          message={'Error en el pago'}
          onCloseCallback={deleteMessages}
        />
      )}
      <Header />
      {appointmentsData.loading ? (
        <h3>Loading...</h3>
      ) : appointmentsData.appointments[0] &&
        appointmentsData.appointments[0].is_payed ? (
        <SuccessPayment
          appointmentData={appointmentsData.appointments[0]}
          goToVideo={goToVideo}
        ></SuccessPayment>
      ) : (
        <PaymentForm
          appointmentsData={appointmentsData}
          getMpPreference={getMpPreference}
          updateAppointmentLight={updateAppointmentLight}
          appointmentId={appointmentId}
          userData={userData}
        ></PaymentForm>
      )}
    </>
  );
}

const mapStateToProps = ({ user, appointments }) => {
  return {
    userData: user,
    appointmentsData: appointments,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getMpPreference: (body) =>
    dispatch({
      type: userActionsTypes.GET_USER_MP_PREFERENCE,
      payload: body,
    }),

  getAppointmentLight: (appointmentId) =>
    dispatch({
      type: appointmentActionsTypes.GET_APPOINTMENT_LIGHT,
      payload: {
        appointmentId,
      },
    }),
  updateAppointmentLight: (id, body) =>
    dispatch({
      type: appointmentActionsTypes.UPDATE_APPOINTMENT_LIGHT_ANONYMOUS,
      payload: { id, body },
    }),
  deleteMessages: () =>
    dispatch({
      type: userActionsTypes.DELETE_MESSAGES,
    }),
});

export default connect(mapStateToProps, mapDispatchToProps)(AnonymousPayment);
